import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'

import { RootState, store } from 'state/store'

export type AppDispatch = typeof store.dispatch
export type AppSelector = TypedUseSelectorHook<RootState>

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: AppSelector = useSelector
